var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 10.125L9.81913 15.6316C10.0439 15.8564 10.1562 16.1198 10.1562 16.4219C10.1562 16.724 10.0417 16.9946 9.8125 17.2337C9.58333 17.4529 9.31771 17.5625 9.01562 17.5625C8.71354 17.5625 8.44991 17.4498 8.22472 17.2243L0.793875 9.78413C0.681292 9.6714 0.598958 9.54927 0.546875 9.41775C0.494792 9.28623 0.46875 9.14531 0.46875 8.995C0.46875 8.84471 0.494792 8.7038 0.546875 8.57228C0.598958 8.44076 0.677083 8.32292 0.78125 8.21875L8.21875 0.78125C8.44792 0.552083 8.71528 0.4375 9.02084 0.4375C9.32639 0.4375 9.59027 0.552083 9.8125 0.78125C10.0417 1.00348 10.1562 1.26736 10.1562 1.57291C10.1562 1.87847 10.0433 2.14418 9.81747 2.37003L4.3125 7.875H16.8758C17.1943 7.875 17.4613 7.98218 17.6768 8.19653C17.8923 8.41091 18 8.67653 18 8.99341C18 9.3103 17.8923 9.57812 17.6768 9.79688C17.4613 10.0156 17.1943 10.125 16.8758 10.125H4.3125Z",
    fill: "#D2D2D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/iconLeft.c1437c79f4b7a7ff540ac062c42eb540.svg";
export { ForwardRef as ReactComponent };